import { NavigableButton } from '@carvana/ds-button';
import Link from '@carvana/ds-link';
import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { appAssetsCdnUrl } from '~/constants/environment';
import { Wrapper } from '../PromoBanner.styles';

type OwnProps = {
  bannerName: string;
  href: string;
};

const backgroundDesktopSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-desktop.svg`;
const backgroundMobileSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-mobile.svg`;
const backgroundTabletSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-tablet.svg`;

export default function GenericBanner({ bannerName, href }: OwnProps) {
  const shopAnalyticsAttributes = JSON.stringify({
    category: bannerName,
    label: 'Shop All New Inventory'
  });

  return (
    <Wrapper className="bg-canvas-muted">
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.lg}px)`}
          srcSet={backgroundDesktopSrc}
        />
        <source
          media={`(min-width: ${breakpoints.sm}px)`}
          srcSet={backgroundTabletSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full"
          src={backgroundMobileSrc}
        />
      </picture>

      <div className="relative z-1 flex flex-1 flex-col justify-center gap-xl sm:gap-lg py-2xl pl-2xl sm:pr-0 lg:py-4xl lg:pl-4xl xl:h-[176px]">
        <h4 className="t-brand-xs max-w-[290px] text-text-inverse sm:max-w-[350px] md:max-w-[290px] lg:t-brand-sm lg:max-w-[510px] xl:max-w-full">
          discover <span className="text-yellow-400">new cars</span> at carvana
        </h4>
        <p className="hidden max-w-[348px] t-body-sm text-text-inverse sm:block lg:max-w-[450px] xl:max-w-full">
          Find your perfect ride — pick your favorite color, features, packages
          and options
        </p>
        <div className="sm:hidden">
          <Link
            className="text-text-inverse"
            data-adobe-id="shop-all-new-inventory"
            data-analytics-attributes={shopAnalyticsAttributes}
            data-analytics-id="Banner"
            data-testid="promo-banner-shop-all-new-inventory"
            href={href}
            size="sm"
          >
            Shop All New Inventory
          </Link>
        </div>
      </div>

      <div className="relative z-1 hidden shrink-0 items-center justify-center px-4xl sm:flex md:pr-2xl lg:px-5xl">
        <NavigableButton
          data-adobe-id="shop-all-new-inventory"
          data-analytics-attributes={shopAnalyticsAttributes}
          data-analytics-id="Banner"
          href={href}
          size="md"
          variant="primary"
        >
          Shop All New Inventory
        </NavigableButton>
      </div>
    </Wrapper>
  );
}
